export default __webpack_public_path__ + "static/media/home_icon.edaf6036.svg";